import { render, staticRenderFns } from "./syncDistributorLog.vue?vue&type=template&id=9f58c63c&scoped=true"
import script from "./syncDistributorLog.vue?vue&type=script&lang=js"
export * from "./syncDistributorLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f58c63c",
  null
  
)

export default component.exports